module.exports = __webpack_public_path__ + "img/knight4cf_03.9e8b5686.jpg";